<template>
    <div class="email-template-composer card p-3" v-bind="attrsStylesClass">
		<TemplateComposer
            v-if="!hideSubject"
			ref="subjectView"
			:readonly="readonly"
			class="mb-4"
			:title="subjectTitle"
			:dynamic-data="templateComposerSubjectDataComputed"
			:hidePersonalization="hidePersonalization"
			:input-debounce-delay="inputDebounceDelay"
			:analytics-props="{label: 'Email subject', ...this.analyticsPropsMethod()}"
			:placeholder="'Type email subject here. ' + personalizePlaceholder"
			:defaultText="defaultSubject"
			:is-simple-composer="isSimpleSubjectComposer"
			v-model="valueData.subject"
			:isValueRequired="isSubjectRequiredComputed"
			@onDefaultRestored="onDefaultRestored"
			@change="onTextChanged"/>
		<TemplateComposer
			:title="bodyTitle"
			ref="bodyView"
			:readonly="readonly"
			:dynamic-data="templateComposerBodyDataComputed"
			class="card1 p-31"
			:hidePersonalization="hidePersonalization"
			:input-debounce-delay="inputDebounceDelay"
			:analytics-props="{label: 'Email body', ...this.analyticsPropsMethod()}"
			:placeholder="'Type email message here. ' + personalizePlaceholder"
			:defaultText="defaultBody"
			:isValueRequired="isBodyRequiredComputed"
			:min-rows="4"
			:multiline="true"
			:is-simple-composer="isSimpleBodyComposer"
			v-model="valueData.body"
			@onDefaultRestored="onDefaultRestored"
			@change="onTextChanged"/>
	</div>
</template>

<script>
    import TemplateComposer from "@/core/components/template/TemplateComposer.vue";
	import BaseVModelView from "@/core/components/BaseVModelView.vue";
	import {templateComposerBodyData, templateComposerCommonData} from "@/core/components/template/PlaceholdersData";

	export default {
        name: "EmailTemplateComposer",
		extends: BaseVModelView,
		components: {TemplateComposer},
		inheritAttrs: false,

		props:{
			readonly: Boolean,
			inputDebounceDelay: Number,
			modelValue:Object,
			defaultSubject: String,
			defaultBody: String,
			hidePersonalization: Boolean,
            hideSubject: Boolean,
			isSimpleSubjectComposer: {Boolean, default: true},
			isSimpleBodyComposer: Boolean,
			subjectTitle: {String, default: "Subject"},
			bodyTitle: {String, default: "Body"},
			subjectPersonalization: null,
			bodyPersonalization: null,
		},
		watch: {
			modelValue: {
				immediate: true,
				handler(newVal, oldVal) {
					if(newVal){
						this.valueData = newVal
					}
				},
			},
		},
		data: () => ({
			valueData:{
				subject:"",
				body:""
			},
		}),
		methods:{

			async validate(){
				let [subjectRes, bodyRes] = await Promise.all([
					this.$refs.subjectView ? this.$refs.subjectView.validateFormRes() : true,
					this.$refs.bodyView ? this.$refs.bodyView.validateFormRes() : true,
				])
				return subjectRes && bodyRes
			},

			onDefaultRestored(){
				this.valueData._wasChangedManually = false
				this.notifyValueChanged()
			},

			onTextChanged(){
				console.log("EmailTemplateComposer: valueData._wasChangedManually")
				this.valueData._wasChangedManually = true
				this.notifyValueChanged()
			},

		},

		computed: {
			personalizePlaceholder() {
				return this.hidePersonalization ? "" : "Use the 'Personalize' dropdown above to personalize it further."
			},

			templateComposerBodyDataComputed(){
				return this.bodyPersonalization || templateComposerBodyData
			},
			templateComposerSubjectDataComputed(){
				return this.subjectPersonalization || templateComposerCommonData
			},

			isSubjectRequiredComputed(){
				return this.modelValue._isSubjectRequired == null ? true : this.modelValue._isSubjectRequired
			},

			isBodyRequiredComputed(){
				return this.modelValue._isBodyRequired == null ? true : this.modelValue._isBodyRequired
			},

		},
	}
</script>

<style>
	.email-template-composer textarea{
		font-size: 12px;
	}
</style>
